import Storage from '../classes/storage';

export default new Storage();
